import styled from "styled-components";

export const AccordionWrapper = styled.div`
  width: 100%;
  .accordion {
    padding-top: 0rem;
    @media (max-width: 768px) {
      padding-top: 0;
    }
  }
  .card {
    border-radius: 0;
    margin-bottom: -1px;
  }
`;

export const StyledHeader = styled.div`
  border: 1px solid #cccccc;
  .card-header {
    padding: 0.5rem 0.75rem 0.5rem 0.3rem;
  }
`;

export const StyledContent = styled.div`
  background-color: #fbfbfb;
  border: 1px solid #cccccc;
  padding: 0 0 1.5rem 1rem;
`;

 export const AccordionCardHeader = styled.div`
   height: 1rem;
   display: flex;
   align-items: center;
   line-height: 1.5rem;
   font-size: 1.125rem;
   text-align: left;
   @media (max-width: 768px) {
     font-size: 1rem;
   }
 `;

 export const AccordionChevron = styled.div`
   height: 100%;
   min-width: min-content;
 `;

 export const AccordionTitle = styled.div`
   padding: 0 1rem;
   white-space: nowrap;
   overflow: hidden;
   text-overflow: ellipsis;
   flex: 1 1 100%;
   @media (max-width: 767px) {
     padding: 0 0.5rem;
     padding-top: 0.22rem;
   }
 `;

 export const AccordionStatus = styled.div``;